module.exports = "/assets/a4f88148592a2ce69362ed2246f67aa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/CI.png
// module id = 1266
// module chunks = 0